export const JAMPP = "jampp"
export const APRHN = "aprhn"
export const AMC = "amc"